module.exports = __webpack_public_path__ + "static/media/8.5804ec94.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/8.png
// module id = 746
// module chunks = 0